export const CONSTS = {
  USER_ID_STORE: "cd84f264-8106-400f-baf7-dea2a9f3bd61",
  //
  COLUMN_ORDER_MM_MANAGEMENT_UNIT: "c1d2c426-434b-4593-94d5-6bf3e7e02adf",
  COLUMN_ORDER_MM_MEASURES: "bc62e5ab-f66b-413a-8f61-3b5ac9745fcf",
  COLUMN_ORDER_MM_PLANNIG: "43b8bc89-b0d2-48d5-ae09-cee765222217",
  COLUMN_ORDER_MM_BUDGET: "90402d3d-0692-43ec-bba7-e34082c792ff",
  COLUMN_ORDER_MM_WORK_PLANS: "9cd01f0d-545f-4b20-bcd0-6dd0cdabbbc1",
  COLUMN_ORDER_MM_WORKORDER: "3cdbcaa9-4137-41c1-8e2d-6a1be79d3ff1",
  COLUMN_ORDER_MM_PERFORMANCE: "bbed20a0-1771-42d1-91f0-3bb1d783d1d5",
  COLUMN_ORDER_MM_OBLIGATIONS: "0d0a3676-8dc3-4bc5-914d-f40381fd5953",
  COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT: "3d83bb00-4760-4a52-8fa5-34bc80b9b6df",
  COLUMN_ORDER_CATALOG_MEASURES: "8cf3cfc1-af63-4963-b582-c4081431b1f9",
  COLUMN_ORDER_CATALOG_WORK_PLANS: "56a6c238-a518-4f67-a5f6-4a82b5745379",
  COLUMN_ORDER_CATALOG_WORK_ORDERS: "37a66682-9229-4cb4-ab10-b73fe58499fa",
  COLUMN_ORDER_CATALOG_DISCIPLINE: "4b04459e-673c-4c9b-9b5d-5249cb299b33",
  COLUMN_ORDER_CATALOG_AREA: "d1af0640-5ed0-4582-bab6-dfbd94cc904b",
  COLUMN_ORDER_CATALOG_FINANCIAL: "c798346a-b94a-402a-ac30-4cf618a1fca9",
  COLUMN_ORDER_CATALOG_WORK_RESOURCES: "82afe891-b3b1-4289-8555-a5964e7e699d",
  COLUMN_ORDER_CATALOG_NATURE_PROTECTION:
    "07f092e6-89c8-4e05-becd-eec39fd0b904",
  COLUMN_ORDER_CATALOG_GEBRUIKERSBEHEER: "89ac2b40-7bde-4391-954e-4ff5b5f39ff8",
  COLUMN_ORDER_CATALOG_USERS_ORGANIZATIONS: "04e94552-ab75-4bf7-83cc-717a32d6a44d",
  COLUMN_ORDER_CATALOG_PLANNING_PATROON: "a26e3231-7955-41dc-b38b-e51cd1319b7b",
  COLUMN_ORDER_CATALOG_PLANNING_PERIOD: "1f1b57f2-ff18-4a3a-b8b7-e56a038396f5",
  EMPTY_TABLE_RESPONSE: {
    "result": {
      "status": "OK"
    },
    "meta": {
      "total_found": 0,
      "total_in_response": 0,
      "current_page": 0,
      "total_pages": 0,
      "monitoring": {
        "OK": 0,
        "WARNING": 0,
        "CRITICAL": 0
      }
    },
    "data": []
  }
};
